import React from 'react';
import { observer } from 'mobx-react';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import FsDefaultDialog from 'ui-elements/modals/FsDefaultDialog';
import FsPaymentMethodForm from 'ui-elements/forms/FsPaymentMethodForm';

interface PaymentMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PaymentMethodModal: React.FC<PaymentMethodModalProps> = ({
  isOpen,
  onClose,
}) => {
  const {
    paymentMethod: { getPaymentDetailsSnapshot },
  } = useAppContext();

  return (
    <FsDefaultDialog
      disableBackdropClick
      disableEscapeKeyDown
      title={defaultLocales.paymentMethod}
      isOpen={isOpen}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
    >
      <FsPaymentMethodForm onClose={onClose} {...getPaymentDetailsSnapshot()} />
    </FsDefaultDialog>
  );
};

export default observer(PaymentMethodModal);
